import * as Yup from 'yup'

const productFabricSchema = Yup.object().shape({
  label: Yup.string().required('Required')
})

export default productFabricSchema
